var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPix = function SvgPix(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M58.667 16 32 5.333 5.333 16v10.667h8.107V43.52q-5.547.64-8.107 1.493v13.654h53.334V45.013l-1.92-.426q-2.561-.64-6.187-1.067V26.667h8.107zM32 11.093l21.333 8.534v1.706H10.667v-1.706zm13.44 15.574v16.426l-5.333-.213V26.667zm-10.667 0v16h-5.546v-16zm-10.666 0V42.88l-5.334.213V26.667zm-13.44 26.666V49.28l1.706-.213Q20.694 48 32 48q11.307 0 19.627 1.067l1.706.213v4.053z"
  })));
};
export default SvgPix;